export const isInvalidValue = (value: any) => {
  if (!value || value === '' || value === null || value === undefined || value === 'null' || value === 'undefined') {
    return true;
  } else {
    return false;
  }
}

export const levenshteinDistance = (str1: string, str2: string): number => {
  const len1 = str1.length;
  const len2 = str2.length;

  const matrix: number[][] = Array(len1 + 1)
    .fill(null)
    .map(() => Array(len2 + 1).fill(0));

  for (let i = 0; i <= len1; i++) {
    matrix[i][0] = i;
  }

  for (let j = 0; j <= len2; j++) {
    matrix[0][j] = j;
  }

  for (let i = 1; i <= len1; i++) {
    for (let j = 1; j <= len2; j++) {
      const cost = str1[i - 1] === str2[j - 1] ? 0 : 1;

      matrix[i][j] = Math.min(
        matrix[i - 1][j] + 1,
        matrix[i][j - 1] + 1,
        matrix[i - 1][j - 1] + cost
      );
    }
  }

  return matrix[len1][len2];
}

export const COMMON_EMAIL_DOMAINS = [
  'gmail.com',
  'hotmail.com',
  'outlook.com',
  'yahoo.com',
  'yahoo.com.br',
  'icloud.com',
  'live.com',
  'uol.com.br',
  'bol.com.br',
  'terra.com.br',
  'ig.com.br',
  'globo.com',
  'globomail.com',
  'oi.com.br',
  'r7.com',
  'zipmail.com.br',
  'me.com',
];

export const evalEmailSuggestion = (email: string, threshold: number = 2): string | null => {
  if (!email?.includes('@')) {
    return null;
  }

  const parts = email.split('@');

  if (parts.length !== 2) {
    return null;
  }

  const [localPart, domain] = parts;

  if (!domain || domain.trim() === '') {
    return null;
  }

  const getDomainParts = (fullDomain: string) => {
    const lastDotIndex = fullDomain.lastIndexOf('.');

    if (lastDotIndex === -1) {
      return { name: fullDomain, extension: '' };
    }

    return {
      name: fullDomain.substring(0, lastDotIndex),
      extension: fullDomain.substring(lastDotIndex)
    };
  };

  const userDomainParts = getDomainParts(domain.toLowerCase());

  let bestMatch: string | null = null;
  let bestDistance = threshold + 1;

  for (const commonDomain of COMMON_EMAIL_DOMAINS) {
    const commonDomainParts = getDomainParts(commonDomain.toLowerCase());

    const distance = levenshteinDistance(userDomainParts.name, commonDomainParts.name);

    if (distance > 0 && distance < bestDistance) {
      bestDistance = distance;
      bestMatch = commonDomain;
    }
  }

  if (bestMatch && bestDistance <= threshold) {
    return `${localPart}@${bestMatch}`.toLowerCase();
  }

  return null;
}
